import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="wrap">
      <div className="foot">
        <div>
          <h4>Haven Crest Health</h4>
          <p>
            Free patient advocacy and care coordination. A navigator gathers your records from every
            provider, explains them in plain language, and coordinates your care, through your own
            health inbox. Voluntary, free, and yours to keep.
          </p>
        </div>
        <div>
          <h4>Product</h4>
          <Link to="/services">How it works</Link>
          <Link to="/care-navigators">Navigators</Link>
          <Link to="/nutrition">Nutrition</Link>
          <Link to="/oncology">Cancer care</Link>
          <Link to="/cardiovascular">Heart health</Link>
        </div>
        <div>
          <h4>Company</h4>
          <Link to="/about">About</Link>
          <Link to="/contact">Get an advocate</Link>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </div>
        <div>
          <h4>Contact</h4>
          <a href="mailto:info@havencresthealth.com">info@havencresthealth.com</a>
          <a href="mailto:records@havencresthealth.com">records@havencresthealth.com</a>
          <p className="muted" style={{ marginTop: '.8rem', fontSize: '.85rem' }}>
            The records address is for providers' offices sending records back.
          </p>
        </div>
      </div>
      <div className="foot__legal">
        <div>
          © 2026 Haven Crest Health. Haven Crest Health is a service of <strong>AfterImage Labs, Inc.</strong>
        </div>
        <div>
          <strong>Plain-language notice:</strong> Haven Crest Health is a free, voluntary service that helps you obtain,
          organize, and understand your own medical records and navigate your care. We are not a medical provider and
          do not give medical advice. If a provider charges a fee for records you ask us to request, that fee is your
          responsibility; we tell you before it applies.
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
